<template>
  <v-dialog
    :value="dialog"
    :max-width="500"
    persistent
    :retain-focus="false"
    scrollable
    @keydown.esc="escape(closeDialog)"
    @click:outside="escape(closeDialog)"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t('document.createDocument') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-5">
        <p-file-input
          v-model="files"
          :library-file-type="fileType.document"
          hide-details="auto"
          multiple
          clearable
        ></p-file-input>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn
          text
          @click="closeDialog"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          :disabled="files.length === 0 || !isModelChanged()"
          color="primary"
          text
          @click.prevent="save">{{ $t('upload') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions } from 'vuex'
import { fileType } from '@/constants'

import PBtnIcon from '@/components/PBtnIcon'
import PFileInput from '@/components/PFileInput'

import dialogMixin from '@/mixins/dialog.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'
import snackbarMixin from '@/mixins/snackbar.mixin'


export default {
  components: {
    PFileInput,
    PBtnIcon
  },


  mixins: [
    dialogMixin,
    unsavedChangesMixin,
    snackbarMixin
  ],


  data () {
    return {
      fileType,
      files: []
    }
  },


  methods: {
    ...mapActions('document', ['createDocuments']),

    onDialogOpen () {
      this.files = []
      this.initWatchedModel('files')
    },

    async save () {
      try {
        if (this.files.length === 0) return

        this.showSnackbarProcessing()
        await this.createDocuments(this.files)

        this.showSnackbarSuccess(this.$t('document.documentCreated'))
        this.closeDialog()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
